import React, { useState, useEffect } from "react";
import "./Styles/LoginPage.css";
import { useDispatch } from "react-redux";
import { loginUser } from "../redux/apiCall/authCall";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ButtonComponent from "../components/ButtonComponent";
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBRow,
  MDBCol,
  MDBInput,
} from "mdb-react-ui-kit";
import Logo from "../assets/log.png";
import adminLogo from "../assets/adminLog.jpg";

const LoginPage = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.state?.signupSuccess) {
      toast.success("Account created successfully! Please log in.");
    }
  }, [location.state?.signupSuccess]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenForOtp = urlParams.get("token");
    try {
      if (tokenForOtp) {
        // Send a request to your backend to verify the token
        axios
          .post(`https://api.michelbandalidesign.com/api/admin/auth/login/${tokenForOtp}`)
          .then((response) => {
            // console.log("response", response);

            if (response.data.valid) {
              // console.log("first", response.data.user); // Console data here
              toast.success("Authenticated! Please login");
              navigate("/login");
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  
    if (!email || !password) return;
  
    dispatch(loginUser(email.trim(), password))
      .then((payload) => {
        if (payload?.token) {
          toast.success("Logged in Successfully !");
          navigate("/");
        }
      })
      .catch(() => {});
  };
  

  return (
    <MDBContainer className="my-5 margin-zero-auto login-auth-page">
      <MDBCard>
        <MDBRow className="g-0">
          <MDBCol md="3">
            <img
              src={adminLogo}
              alt="login form"
              className="rounded-start img-login-admin-user w-100"
            />
          </MDBCol>

          <MDBCol md="6">
            <MDBCardBody className="d-flex flex-column">
              <div className="d-flex flex-row mt-2">
                <img className="logo" src={Logo} width={328} height={58} />
              </div>

              <h5
                className="fw-normal my-4 pb-3"
                style={{ letterSpacing: "1px" }}
              >
                Sign into your account
              </h5>

              {location.state?.signupSuccess && (
                <div className="signup-success-banner">
                  Your account was created. Log in with the same email and password.
                </div>
              )}

              <MDBInput
                wrapperClass="mb-4"
                id="formControlLg"
                type="email"
                required
                size="sm"
                className="input-input-input"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <MDBInput
                wrapperClass="mb-4"
                id="formControlLg"
                type="password"
                className="input-input-input"
                size="sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <ButtonComponent
                type="button"
                onClick={SubmitHandler}
                className="btn btn-primary btn-block"
              >
                Login
              </ButtonComponent>
            </MDBCardBody>

            <div className="loginpage-main-container-span d-flex align-items-left mt-3 ml-2">
              <p className="fs-5">
                Do not have an account?{" "}
                <Link className="fw-bold text-decoration-none" to="/signup">
                  Sign up
                </Link>
              </p>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBCard>
    </MDBContainer>
  );
};

export default LoginPage;
